import React, { useState, useEffect } from 'react';
import { Search } from 'lucide-react';
import { DateRangePicker } from '../../../../../components/ui/DateRangePicker';
import { FilterableSelect } from '../../../../../components/ui/FilterableSelect';
import { PICKING_STATE_OPTIONS } from '../../../../../features/pickups/pickupsConstants';

/**
 * Filter bar of the pickups listing.
 *
 * @param {object} props
 * @param {object} props.filters - The slice's `filters`
 * @param {(fieldOrPatch: string|object, value?: *) => void} props.onFilterChange
 * @param {Array<{value: number, label: string}>} props.sellerOptions - Without
 *   the "Todas" sentinel, which is prepended here.
 */
export const PickupFilters = ({ filters, onFilterChange, sellerOptions = [] }) => {
  const [searchInput, setSearchInput] = useState(filters.search || '');

  // Debounce for search
  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchInput !== filters.search) {
        onFilterChange('search', searchInput);
      }
    }, 1500); // 1.5s debounce
    return () => clearTimeout(handler);
  }, [searchInput, filters.search, onFilterChange]);

  const sellerSelectOptions = [{ value: 'all', label: 'Todas' }, ...sellerOptions];

  const hasFilters =
    searchInput.trim() !== '' || filters.state !== 'all' || filters.seller !== 'all';

  return (
    <div className="flex flex-col md:flex-row flex-wrap items-center gap-4">
      <div className="flex-1 min-w-[300px] flex items-center gap-2 bg-white dark:bg-[#1a1a1a] border border-border rounded-xl px-4 py-2">
        <Search size={16} className="text-text-muted flex-shrink-0" />
        <input
          type="text"
          placeholder="Buscar por orden, delivery, tracking, conductor o ruta..."
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          className="bg-transparent text-sm w-full outline-none dark:text-white placeholder:text-text-muted"
        />
      </div>

      <DateRangePicker
        startDate={filters.start_date}
        endDate={filters.end_date}
        onChange={onFilterChange}
      />

      <FilterableSelect
        label="Estado:"
        value={filters.state}
        onChange={(val) => onFilterChange('state', val)}
        options={PICKING_STATE_OPTIONS}
      />

      <FilterableSelect
        label="Seller:"
        value={filters.seller}
        onChange={(val) => onFilterChange('seller', val)}
        options={sellerSelectOptions}
      />

      {hasFilters && (
        <button
          onClick={() => {
            setSearchInput('');
            onFilterChange({ search: '', state: 'all', seller: 'all' });
          }}
          className="text-sm font-medium text-text-muted hover:text-ninja-dark dark:hover:text-white transition-colors px-2 ml-auto"
        >
          Limpiar filtros
        </button>
      )}
    </div>
  );
};
